export class ElaborationEntityConstants{
    public static PRINCIPAL_ACTOR = "principal_actor";
    public static LEGAL_PRINCIPAL_ACTOR = "legal_principal_actor";
    public static LEGAL_DEFENDANT = "legal_defendant";
    public static OTHER_COUNTER_PARTS = "other_counter_parts";
    public static IMPORTO_ECONOMICO = 'IMPORTO_ECONOMICO';
    public static AUT_GIUDIZIARIA = 'court';
    public static COURT_SECTION = 'court_section';
    public static JUDGE ='judge';
    public static CASE_NUMBER = "case_number";
}
